"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _ArrayHelper = require("./ArrayHelper");

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _ResumeSuspendListeners = require("./ResumeSuspendListeners");

var _AppNativeStorage = require("../utils/AppNativeStorage");

// import {getPromise, PLUGIN_DEVICE_INFO} from './CordovaHelper';
var _isInternetExplorer = null;
var onlineListeners = [];
var offlineListeners = [];
var onlineHiccupListeners = [];
var offlineHiccupListeners = [];
var initializingOrDone = false;
var _isSuspended = false;
var _isAndroid = null;
var _isiOS = null;
var _isBrowser = null;
(0, _ResumeSuspendListeners.addOnSuspendListener)(function () {
  _isSuspended = true;
});
(0, _ResumeSuspendListeners.addOnResumeListener)(function () {
  _isSuspended = false;
});
var onlineOfflineTimeout = null;
var TIME_BEFORE_FIRING_ONLINE_OR_OFFLINE = 2000;
var canFireOnlineOffline = true;
var wasOnline;
var isOnline;

var DeviceInfoHelper = /*#__PURE__*/function () {
  function DeviceInfoHelper() {
    (0, _classCallCheck2["default"])(this, DeviceInfoHelper);
  }

  (0, _createClass2["default"])(DeviceInfoHelper, null, [{
    key: "_initListenersIfNeeded",
    value: function _initListenersIfNeeded() {
      var _this = this;

      var calledFromChosenInitialized = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // target may not be available yet
      if (initializingOrDone && !calledFromChosenInitialized) {
        return;
      }

      initializingOrDone = true;

      if (!_config["default"] || !(0, _AppNativeStorage.getStorageShouldBeAvailable)()) {
        if (!_config["default"]) {
          console.log('target not yet available in online ably device helper');
        } else {
          console.log('storage not yet available in online ably device helper');
        }

        setTimeout(function () {
          _this._initListenersIfNeeded(true);
        }, 100);
        return;
      }

      var onOnline = function onOnline() {
        onlineHiccupListeners.forEach(function (listener) {
          return listener();
        });

        if (canFireOnlineOffline) {
          wasOnline = isOnline;
        }

        isOnline = true;
        clearTimeout(onlineOfflineTimeout);
        canFireOnlineOffline = false;
        onlineOfflineTimeout = setTimeout(function () {
          canFireOnlineOffline = true;

          if (wasOnline !== isOnline) {
            if (isOnline) {
              onlineListeners.forEach(function (listener) {
                return listener();
              });
            } // else {
            //   offlineListeners.forEach(listener => listener())
            // }

          }
        }, TIME_BEFORE_FIRING_ONLINE_OR_OFFLINE);
      };

      var onOffline = function onOffline() {
        offlineHiccupListeners.forEach(function (listener) {
          return listener();
        });

        if (canFireOnlineOffline) {
          wasOnline = isOnline;
        }

        isOnline = false;
        clearTimeout(onlineOfflineTimeout);
        canFireOnlineOffline = false;
        onlineOfflineTimeout = setTimeout(function () {
          canFireOnlineOffline = true;

          if (wasOnline !== isOnline) {
            // if (isOnline) {
            //   onlineListeners.forEach(listener => listener())
            // }
            if (!isOnline) {
              offlineListeners.forEach(function (listener) {
                return listener();
              });
            }
          }
        }, TIME_BEFORE_FIRING_ONLINE_OR_OFFLINE);
      };

      if (_config["default"].useAblyForOnlineDetermining && window.ablyConnectivity && _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ABLY_ENABLED)) {
        window.ablyConnectivity.addOnChangeListener(function (connectState) {
          if (connectState === 'connected') {
            onOnline();
          } else if (window.ablyConnectivity.reliable) {
            onOffline();
          }
        });
      } else {
        document.addEventListener('online', function () {
          onOnline();
        });
        document.addEventListener('offline', function () {
          onOffline();
        });
      }
    } // static getDeviceOrientation() {
    //   return getPromise(PLUGIN_DEVICE_INFO, 'getDeviceOrientation');
    // }

  }, {
    key: "isAndroid",
    value: function isAndroid() {
      if (_isAndroid === null) {
        _isAndroid = window.cordova && window.cordova.platformId && window.cordova.platformId === 'android' && window.cordova.version !== 'N/A';
      }

      return _isAndroid;
    }
  }, {
    key: "isBrowser",
    value: function isBrowser() {
      if (_isBrowser === null) {
        _isBrowser = !DeviceInfoHelper.isAndroid() && !DeviceInfoHelper.isiOS();
      }

      return _isBrowser;
    }
  }, {
    key: "isMobileBrowser",
    value: function isMobileBrowser() {
      return DeviceInfoHelper.isMobileAndroidBrowser() || DeviceInfoHelper.isMobileiOSBrowser();
    }
  }, {
    key: "isSafari",
    value: function isSafari() {
      return _isBrowser && Boolean(navigator.vendor) && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1;
    }
  }, {
    key: "isFirefox",
    value: function isFirefox() {
      return _isBrowser && navigator.userAgent && navigator.userAgent.indexOf('Firefox') > -1;
    }
  }, {
    key: "isEdge",
    value: function isEdge() {
      return window.navigator.userAgent.indexOf('Edge') >= 0;
    }
  }, {
    key: "hasNotch",
    value: function hasNotch() {
      var phoneModels = ['iPhone10,3', 'iPhone10,6', 'iPhone11,8', 'iPhone11,2', 'iPhone11,4', 'iPhone11,6'];

      if (!DeviceInfoHelper.isiOS()) {
        return false;
      } else {
        var model = window.device && window.device.model ? window.device.model : 'undefined model';
        var index = phoneModels.indexOf(model);
        return index !== -1;
      }
    }
  }, {
    key: "isiOS",
    value: function isiOS() {
      if (_isiOS === null) {
        _isiOS = window.cordova && window.cordova.platformId && window.cordova.platformId === 'ios' && window.cordova.version !== 'N/A';
      }

      return _isiOS;
    }
  }, {
    key: "getOS",
    value: function getOS() {
      if (DeviceInfoHelper.isAndroid()) {
        return 'android';
      }

      if (DeviceInfoHelper.isiOS()) {
        return 'ios';
      }

      return null;
    }
  }, {
    key: "isMobileiOSBrowser",
    value: function isMobileiOSBrowser() {
      return !DeviceInfoHelper.isiOS() && !DeviceInfoHelper.isAndroid() && (navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/iPad/i));
    }
  }, {
    key: "isMobileAndroidBrowser",
    value: function isMobileAndroidBrowser() {
      return !DeviceInfoHelper.isiOS() && !DeviceInfoHelper.isAndroid() && (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i));
    }
  }, {
    key: "getAndroidVersion",
    value: function getAndroidVersion() {
      if (this.isAndroid()) {
        var ua = navigator.userAgent.toLowerCase();
        var match = ua.match(/android\s([0-9.]*)/i);
        return match ? match[1] : 0;
      }

      return 0;
    }
    /**
     * Right at the start ably might be wrong
     * @param ignoreAbly
     * @returns {boolean}
     */

  }, {
    key: "isOnline",
    value: function isOnline() {
      var ignoreAbly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_config["default"].useAblyForOnlineDetermining && _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ABLY_ENABLED) && !ignoreAbly && window.ablyConnectivity && window.ablyConnectivity.reliable && window.ablyConnectivity.state !== 'initializing') {
        return window.ablyConnectivity.state === 'connected';
      }

      if (window.navigator.connection) {
        if (window.navigator.connection.type) {
          return window.navigator.connection.type !== 'none';
        } else if (window.navigator.connection.effectiveType) {
          return window.navigator.connection.effectiveType !== 'none';
        }

        return false;
      } // optimistic approach


      return true;
    }
  }, {
    key: "addOnlineListener",
    value: function addOnlineListener(listener) {
      DeviceInfoHelper._initListenersIfNeeded();

      if (!onlineListeners.includes(listener)) {
        onlineListeners.push(listener);
      }
    }
  }, {
    key: "addOfflineListener",
    value: function addOfflineListener(listener) {
      DeviceInfoHelper._initListenersIfNeeded();

      if (!offlineListeners.includes(listener)) {
        offlineListeners.push(listener);
      }
    }
  }, {
    key: "removeOnlineListener",
    value: function removeOnlineListener(listener) {
      DeviceInfoHelper._initListenersIfNeeded();

      (0, _ArrayHelper.removeElement)(onlineListeners, listener);
    }
  }, {
    key: "removeOfflineListener",
    value: function removeOfflineListener(listener) {
      DeviceInfoHelper._initListenersIfNeeded();

      (0, _ArrayHelper.removeElement)(offlineListeners, listener);
    }
    /**
     * Adds a listener that is called for every moment a connection changes to being available.
     * The normal listener is only called after a short moment of time to avoid such 'hiccups'
     * @param listener
     */

  }, {
    key: "addOnlineHiccupListener",
    value: function addOnlineHiccupListener(listener) {
      DeviceInfoHelper._initListenersIfNeeded();

      if (!onlineHiccupListeners.includes(listener)) {
        onlineHiccupListeners.push(listener);
      }
    }
  }, {
    key: "removeOnlineHiccupListener",
    value: function removeOnlineHiccupListener(listener) {
      DeviceInfoHelper._initListenersIfNeeded();

      (0, _ArrayHelper.removeElement)(onlineHiccupListeners, listener);
    }
    /**
     * Adds a listener that is called for every moment a connection changes to being unavailable.
     * The normal listener is only called after a short moment of time to avoid such 'hiccups'
     * @param listener
     */

  }, {
    key: "addOfflineHiccupListener",
    value: function addOfflineHiccupListener(listener) {
      DeviceInfoHelper._initListenersIfNeeded();

      if (!offlineListeners.includes(listener)) {
        offlineHiccupListeners.push(listener);
      }
    }
  }, {
    key: "removeOfflineHiccupListener",
    value: function removeOfflineHiccupListener(listener) {
      DeviceInfoHelper._initListenersIfNeeded();

      (0, _ArrayHelper.removeElement)(offlineHiccupListeners, listener);
    }
  }, {
    key: "isInternetExplorer",
    value: function isInternetExplorer() {
      if (_isInternetExplorer !== null) {
        return _isInternetExplorer;
      }

      _isInternetExplorer = false;

      if (DeviceInfoHelper.isBrowser()) {
        var userAgent = window.navigator.userAgent;

        if (userAgent) {
          var ie10 = userAgent.indexOf('MSIE') >= 0;
          var ie11 = userAgent.indexOf('rv:11') >= 0;
          _isInternetExplorer = ie10 || ie11;
        }
      }

      return _isInternetExplorer;
    }
  }, {
    key: "isSuspended",
    value: function isSuspended() {
      return _isSuspended;
    }
  }]);
  return DeviceInfoHelper;
}();

exports["default"] = DeviceInfoHelper;